import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0fde0d54")

_pushScopeId("data-v-0fde0d54")
const _hoisted_1 = { class: "recommend-food-item-image-view" }
const _hoisted_2 = { class: "recommend-food-item-value-area" }
const _hoisted_3 = { class: "recommend-food-item-status" }
const _hoisted_4 = { class: "recommend-food-item-name-view" }
const _hoisted_5 = { class: "recommend-food-item-name-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "recommend-food-item",
    style: _ctx.styleRoot,
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickFood(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("img", {
        class: "recommend-food-item-image",
        src: _ctx.getImage(),
        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
      }, null, 40, ["src"])
    ]),
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", _hoisted_3, "在庫あり", 512), [
        [_vShow, _ctx.isPantryFood()]
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getName()), 1)
      ])
    ])
  ], 4))
})